import React, { useEffect } from 'react'
import Company from "../../../assets/images/company certificate.png";
import PersonalId from "../../../assets/images/personal id.png";
import Bank from "../../../assets/images/bank document.png";
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

const selectUser = createSelector(
    (state: any) => state.User,
    (user) => user?.user
);

const OnBoardingBankID = () => {
    const user = useSelector(selectUser);

    useEffect(() => {
    }, [user]);
    const isIdBankDetails = user?.storeStatus?.isIdBankDetails;

    return (
        <>
            <div className='d-grid gap-3 align-items-center justify-content-center flex-column'>
                <div className='d-flex align-items-center justify-content-center'>
                    <div className='py-3  d-flex align-items-center justify-content-center flex-column me-3 border rounded border-success w-50' >
                        <h5 className='text-gray-200 text-black-50'>Individual Seller</h5>
                        <div className='d-flex align-items-center justify-content-between w-75'>
                            <div className=' text-center'>
                                <img
                                    className=" mx-0 mb-1 p-0 object-contain "
                                    style={{ width: "40px", height: "40px" }}
                                    src={PersonalId}
                                    alt="Email Communication"
                                />
                                <h5 className='text-black-50 '>Personal ID</h5>
                            </div>
                            <div className='text-center'>
                                <img
                                    className=" mx-0 mb-1 p-0 object-contain "
                                    style={{ width: "40px", height: "40px" }}
                                    src={PersonalId}
                                    alt="Email Communication"
                                />
                                <h5 className='text-black-50 '>Bank Document</h5>
                            </div>
                        </div>
                    </div>
                    <div className='py-3  d-flex align-items-center justify-content-center flex-column me-3 border rounded border-success w-50' >
                        <h5 className='text-gray-200 text-black-50'>Corporate
                        </h5>
                        <div className='d-flex align-items-center justify-content-between w-75'>
                            <div className=' text-center'>
                                <img
                                    className=" mx-0 mb-1 p-0 object-contain "
                                    style={{ width: "40px", height: "40px" }}
                                    src={Company}
                                    alt="Email Communication"
                                />
                                <h5 className='text-black-50 '>Company Cetificate</h5>
                            </div>
                            <div className='text-center'>
                                <img
                                    className=" mx-0 mb-1 p-0 object-contain "
                                    style={{ width: "40px", height: "40px" }}
                                    src={PersonalId}
                                    alt="Email Communication"
                                />
                                <h5 className='text-black-50 '>Bank Document</h5>
                            </div>
                        </div>
                    </div>
                </div>
                <h1 className='text-center fs-3'> Register your Business on Buypass</h1>
                {/* <h4 className='text-center text-gray-300 m-0 p-0 text-black-50'>no video</h4> */}


                {!isIdBankDetails ? (
  <div className="d-flex flex-column align-items-center gap-3">
    <Link to="/bank-information">
      <button
        type="button"
        data-testing-Id="idBankAdd_onBoarding"
        className="btn btn-success"
      >
        Add
      </button>
    </Link>
  </div>
) : (
  <div className="d-flex flex-column align-items-center gap-3">
    <Link to="/bank-information">
      <button
        type="button"
        data-testing-Id="idBankUpdate_onBoarding"
        className="btn btn-success"
      >
        Update
      </button>
    </Link>
    <div className="d-flex align-items-center gap-2 p-2 rounded bg-success bg-opacity-25">
      <i className="bx bx-check-circle text-success fs-5"></i>
      <p className="mb-0 text-black-50">
        Your business information has been uploaded successfully!
      </p>
    </div>
  </div>
)}

                <h4 className='text-center text-gray-300 m-0 p-0 text-black-50 '>Your valid government ID and Bank documents will be used to process your payments.
                </h4>
            </div>
        </>
    )
}

export default OnBoardingBankID
